export default __webpack_public_path__ + "static/media/sh_dark.c99be4ab.png";